// import fetch from '../utils/fetch';
import fetch from '../utils/fetch';

// 获取类目数据
export function goodsInfoMenu() {
    return fetch({
        method: 'GET',
        url: 'goodsInfo/goodsInfoMenu'
    })
}

export function goodsInfoList(params) {
  return fetch({
      method: 'GET',
      url: 'goodsInfo/goodsInfoList',
      params
  })
}